import React, { useEffect, useState } from "react";
import "./yourgoalmodal.scss";
import { Icons } from "../../atoms/Icons";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import Buttons from "../../atoms/Buttons";
import { YOUR_GOALS_TASK_STATUS } from "../../constants/constants";
import LoadingSpinner from "../../atoms/Loader";

const YourGoalModal = (props) => {
  const navigate = useNavigate();
  const { fetching, data } = useSelector((state) => state.yourGoals);
  const dispatch = useDispatch();
  const { getYourGoals } = bindActionCreators(
    actionCreators,
    dispatch, // eslint-disable-line
  );
  // eslint-disable-next-line
  const { investorId } = props;
  const [recommendedGoal, setRecommendedGoal] = useState();
  useEffect(() => {
    if (!props.isTaskUpdated) {
      getYourGoals(investorId);
    }
  }, [props.isTaskUpdated]);
  useEffect(() => {
    setRecommendedGoal(
      data?.goalData, //eslint-disable-line
    );
  }, [data]);
  return (
    <>
      <div className="pensionable-edit-close">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <p className="heading">Your goals</p>
      <p className="sub-heading">
        We recommend the following goals or experiences for you based on your
        membership(s). <br />
        <p className="sub-heading-learn-navigation">
          The
          <Buttons
            name="learn"
            className="tertiary"
            handleClick={() => navigate("/learn/")}
          ></Buttons>
          area can also help you to boost your pension understanding and
          financial confidence.
        </p>
      </p>

      {fetching ? (
        <LoadingSpinner topMargin={65} />
      ) : (
        <Row className="goal-container">
          <Col className="most-popular-pot">
            <Row className="recommended-goals-set gy-4">
              {recommendedGoal?.map((item, index) => {
                return (
                  <Col lg={6} key={index}>
                    {item.goalTasks.map((task, taskIndex) => {
                      return (
                        <Row className="task-name gx-0" key={taskIndex}>
                          <Col xs={1} lg={1}>
                            {task.status ===
                            YOUR_GOALS_TASK_STATUS.NOT_STARTED ? (
                              <span className="radio-circle"></span>
                            ) : (
                              <Icons
                                iconname="form-fields-success-tick"
                                variant="icon-sixteen-px"
                              />
                            )}{" "}
                          </Col>
                          <Col xs={11} lg={11}>
                            <p>{task.title}</p>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default YourGoalModal;
